import { createBrowserRouter, Navigate } from 'react-router-dom';
import { SignIn } from './routes/SignIn';
import { SignUp } from './routes/SignUp';
import { CreateOrganization } from './routes/CreateOrganization';
import { GetStarted } from './routes/GetStarted';
import { Home } from './routes/Home';
import { CreateProject } from './routes/CreateProject';
import { EditProject } from './routes/EditProject';
import { RetentionSettings } from './routes/RetentionSettings';
import { DomainVerification } from './routes/DomainVerification';
import { LlmKeySettings } from './routes/LlmKeySettings';
import { IntegrationSettings } from './routes/IntegrationSettings';
import { Members } from './routes/Members';
import { ScansList } from './routes/ScansList';
import { ScanDiscovery } from './routes/ScanDiscovery';
import { JourneyHealth } from './routes/JourneyHealth';
import { JourneysList } from './routes/JourneysList';
import { JourneyForm } from './routes/JourneyForm';
import { JourneyEvidence } from './routes/JourneyEvidence';
import { JourneyDetail } from './routes/JourneyDetail';
import { JourneyExecutionEvidence } from './routes/JourneyExecutionEvidence';
import { DefectsList } from './routes/DefectsList';
import { DefectDetail } from './routes/DefectDetail';
import { TestCases } from './routes/TestCases';
import { TrackerSettings } from './routes/TrackerSettings';
import { ConnectedValidation } from './routes/ConnectedValidation';
import { RequireAuth } from './auth/RequireAuth';
import { RequireOrg } from './auth/RequireOrg';
import { RequireNoOrg } from './auth/RequireNoOrg';
import { RedirectIfAuthed } from './auth/RedirectIfAuthed';
import { RootLayout } from './routes/RootLayout';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
  {
    path: '/',
    element: (
      <RequireAuth>
        <RequireOrg>
          <Home />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/new',
    element: (
      <RequireAuth>
        <RequireOrg>
          <CreateProject />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/edit',
    element: (
      <RequireAuth>
        <RequireOrg>
          <EditProject />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/domain-verification',
    element: (
      <RequireAuth>
        <RequireOrg>
          <DomainVerification />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/scans',
    element: (
      <RequireAuth>
        <RequireOrg>
          <ScansList />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/scans/:scanId/discovery',
    element: (
      <RequireAuth>
        <RequireOrg>
          <ScanDiscovery />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journey-health',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyHealth />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journeys',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneysList />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journeys/new',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyForm />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journeys/:journeyId/edit',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyForm />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journey-health/:journeyType',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyEvidence />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journey-health/:journeyType/execution',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyExecutionEvidence />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journeys/:journeyId',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyDetail />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/journeys/:journeyId/revisions/:revisionId',
    element: (
      <RequireAuth>
        <RequireOrg>
          <JourneyDetail />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/defects',
    element: (
      <RequireAuth>
        <RequireOrg>
          <DefectsList />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/defects/:defectId',
    element: (
      <RequireAuth>
        <RequireOrg>
          <DefectDetail />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/test-cases',
    element: (
      <RequireAuth>
        <RequireOrg>
          <TestCases />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/tracker-settings',
    element: (
      <RequireAuth>
        <RequireOrg>
          <TrackerSettings />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/projects/:id/connected-validation',
    element: (
      <RequireAuth>
        <RequireOrg>
          <ConnectedValidation />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/settings/retention',
    element: (
      <RequireAuth>
        <RequireOrg>
          <RetentionSettings />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/settings/members',
    element: (
      <RequireAuth>
        <RequireOrg>
          <Members />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/settings/llm-key',
    element: (
      <RequireAuth>
        <RequireOrg>
          <LlmKeySettings />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/settings/integrations',
    element: (
      <RequireAuth>
        <RequireOrg>
          <IntegrationSettings />
        </RequireOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/sign-in',
    element: (
      <RedirectIfAuthed>
        <SignIn />
      </RedirectIfAuthed>
    ),
  },
  {
    path: '/sign-up',
    element: (
      <RedirectIfAuthed>
        <SignUp />
      </RedirectIfAuthed>
    ),
  },
  {
    path: '/getting-started',
    element: (
      <RequireAuth>
        <RequireNoOrg>
          <GetStarted />
        </RequireNoOrg>
      </RequireAuth>
    ),
  },
  {
    path: '/create-organization',
    element: (
      <RequireAuth>
        <RequireNoOrg>
          <CreateOrganization />
        </RequireNoOrg>
      </RequireAuth>
    ),
  },
  {
    path: '*',
    element: <Navigate to="/sign-in" replace />,
  },
    ],
  },
]);
